import React, { useState, useEffect, useCallback } from 'react';
import styled from 'styled-components';
import { Form, Input, Radio, Space, Select} from 'antd';
import axios from 'axios';
import * as _ from 'lodash';

const WorkflowForm = ({folderSettings, workingFolder}) => {

  const [workflowRoutes, setWorkflowRoutes] = useState([]);

  const [form] = Form.useForm();

  const formItemLayout = {
    labelCol: {
      xs: { span: 24 },
      sm: { span: 24 },
    },
    wrapperCol: {
      xs: { span: 24 },
      sm: { span: 24 },
    },
  };

  const onSelect = useCallback((value, { label }) => {

    let routeName = label;
    let routeId = value || '0';

    if (routeId !== '0') {
      routeName = `${label} ${new Date().toLocaleString().replace(',', '')}`;
    } else {
      routeName = '';
    }
  
    form.setFieldValue('routeId', routeId);
    form.setFieldValue('routeName', routeName);

  }, [form]);
  
  useEffect(() => {

    if(_.isEmpty(folderSettings)) return;

    form.setFieldsValue({routeOption: folderSettings.workflowInstanceOption || "1"});

    axios.get(`/api/workflow/getworkflowroutes?folderId=${workingFolder}`).then(res => {

      const routes = res.data.map(({RouteId, RouteName}) => ({label: RouteName, value: RouteId}));
      routes.unshift({label: ' ', value: '0'});

      setWorkflowRoutes(routes);

      const defaultRoute = routes.find(({value}) => value === folderSettings.workflowRoute);

      onSelect(defaultRoute?.value || '0', {label: defaultRoute?.label});
    });

  }, [folderSettings, onSelect, form]);

  return (
    <Container id="workflow-container">
      <Form
        form={form}
        name="workflowForm"
        {...formItemLayout}
        layout='vertical'
        labelAlign="left"
        initialValues={{routeId: '0', routeName: '', routeMessage: ''}}
        style={{width: '100%', height: '100%'}}
      >
      <div style={{height: '100%', width: '100%', display: 'flex', flexDirection: 'column'}}>
          <Form.Item name="routeId" label="Workflow Route">
              <Select
                onChange={onSelect}
                options={workflowRoutes}
              />
          </Form.Item>
          <Form.Item name="routeName" label="Instance Name">
              <Input />
          </Form.Item>
          <Form.Item name="routeMessage" label="Message" className='wf-message-box' style={{flex: '1'}}>
              <Input.TextArea style={{resize: 'none', height: "100%"}} />
          </Form.Item>
          <Form.Item name="routeOption" style={{flex: '0 40px'}}>
            <Radio.Group>
              <Space direction="vertical">
                <Radio value="0">One route instance per file</Radio>
                <Radio value="1">One route instance for all files</Radio>
              </Space>
            </Radio.Group>
          </Form.Item>

      </div>
      </Form>
    </Container>
  );
};

const Container = styled.div`
  height: 100%;
  width: 100%;
  display: flex;
  position: relative;
  overflow: hidden;
  .ant-tabs-nav {
    margin-bottom: 0;
  }
  .ant-tabs-content {
    padding-bottom: 0 !important;
  }
  .ant-form-item {
    margin: 5px 0;
  }
  .ant-space {
    gap: 0 !important;
  }
  .wf-message-box .ant-row {
    display: block;
    height: calc(100% - 25px);
  }
  .wf-message-box .ant-row div:nth-child(2) {
    height: 100%;
  }
  .wf-message-box .ant-row div:nth-child(2) div {
    height: 100%;
  }
`

export default WorkflowForm;